import React, { useContext, useEffect, useState } from "react";
import FooterBtn from "../Components/FooterBtn";
import Breadcrumb from "../Components/Breadcrumb";
import FooterHeader from "../Components/FooterHeader";
import Filter from "../Components/Filter";
import SearchProducts from "../Components/SearchProducts";
import ProductCard from "../Components/ProductCard";
import axios from "axios";
import { API_URL } from "../Url";
// import Pagination from "../Components/atoms/Pgination";
import { ProductContext } from "../context/ProductContext";
import ProductLoader from "../Components/atoms/ProductLoader";
// import { Pagination } from 'react-bootstrap'
import { FaChevronRight } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import Switch from "react-switch";
import { IoIosCloseCircleOutline } from "react-icons/io";
import Pagination from "../Components/atoms/Pagination";

function SearchPage() {
  const { query, setQuery, serachQuery } = useContext(ProductContext);
  // const [sortOption, setSortOption] = useState("");
  const [checked, setChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [sortOption, setSortOption] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const [selectedPrice, setSelectedPrice] = useState("");

  const [searchProducts, setSearchProducts] = useState([]);
  const [productFilterArray, setProductFilterArray] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // Added currentPage state
  console.log("query===>", query);
  console.log("Searchquery===>", serachQuery);

  const uncheckedIcon = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 26,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      III
    </div>
  );

  const checkedIcon = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 26,
        color: "#fff",
        paddingRight: 3,
      }}
    >
      IIIII
    </div>
  );

  const getSearchProducts = async () => {
    setIsLoading(true);

    const obj = {
      variationOptions: productFilterArray, //filterArray
      priceRange: selectedPrice,
      page: currentPage,
      limit: 9,
      sortOrder: sortOption,
    };

    try {
      const res = await axios.post(
        `${API_URL}/products/search?query=${serachQuery}`,
        obj
      );
      if (res?.data) {
        setSearchProducts(res?.data?.data);
        setTotalPages(res?.data?.totalNumberOfPages);
        setQuery("");
        setIsLoading(false);
      }
      // setQuery("")
    } catch (error) {
      //   toast.error(error);
      console.log("Error in fetching search Products", error);
    }
  };
  const handlePriceSelect = (price) => {
    setSelectedPrice(price);
    setCurrentPage(1); // Set current page to 1 whenever a price is selected
  };

  useEffect(() => {
    getSearchProducts();
    console.log("productFilterArray=====>1", currentPage);
  }, [currentPage, productFilterArray, serachQuery, sortOption, selectedPrice]);

  const handlePageChange = (page) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setCurrentPage(page);
  };

  const handleFilterSet = (filterArray) => {
    console.log("handleFilterSet filterArray====>", filterArray);
    setProductFilterArray([...filterArray]);
    if (filterArray.length > 0) {
      setCurrentPage(1);
    }
  };

  const handleChange = (checked) => {
    setChecked(checked);
  };

  console.log("search");
  return (
    <>
      <div className="hidden md:block">
        <Breadcrumb
          breadcrumbs={[
            { title: "Home", path: "/" },
            { title: "Products", path: "/search" },
            // { title: "Shoes", path: "/products/shoes" },
          ]}
        />
      </div>
      {showFilter && (
        <div
          className={`fixed w-full top-16 h-full pb-16 overflow-y-auto z-50 bg-slate-300 left-0 ${
            showFilter ? "block" : "hidden"
          }`}
        >
          <div className="px-3 py-2">
            <div
              className="flex justify-end py-2"
              onClick={() => setShowFilter(false)}
            >
              <IoIosCloseCircleOutline size={30} color="gray" />
            </div>
            <div className=" p-1 rounded-md border-2">
              {/* <label htmlFor="price">Price</label> */}
              <div
                onClick={() => setIsOpen(!isOpen)}
                className="cursor-pointer py-2  px-3 flex justify-between items-center"
              >
                {/* {selectedPrice || "Select price"} */}
                <div className="text-lg">Price</div>
                {isOpen ? (
                  <FaChevronDown color="gray" />
                ) : (
                  <FaChevronRight color="gray" />
                )}
              </div>
              {isOpen && (
                <div className=" ml-4 py-2 space-y-2">
                  <div>
                    <input
                      className=""
                      type="radio"
                      id="0-5000"
                      name="price"
                      value="0-5000"
                      checked={selectedPrice === "0-5000"}
                      onChange={() => handlePriceSelect("0-5000")}
                    />
                    <label htmlFor="0-5000" className="ml-2">
                      Below 5000
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="5000-10000"
                      name="price"
                      value="5000-10000"
                      checked={selectedPrice === "5000-10000"}
                      onChange={() => handlePriceSelect("5000-10000")}
                    />
                    <label htmlFor="5000-10000" className="ml-2">
                      5000-10,000
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="10000-20000"
                      name="price"
                      value="10000-20000"
                      checked={selectedPrice === "10000-20000"}
                      onChange={() => handlePriceSelect("10000-20000")}
                    />
                    <label htmlFor="10000-20000" className="ml-2">
                      10,000-20,000
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="20000-50000"
                      name="price"
                      value="20000-50000"
                      checked={selectedPrice === "20000-50000"}
                      onChange={() => handlePriceSelect("20000-50000")}
                    />
                    <label htmlFor="20000-50000" className="ml-2">
                      Above 20,000
                    </label>
                  </div>
                  {/* Add more options here */}
                </div>
              )}
              {selectedPrice && (
                <div className="flex flex-row-reverse mr-2 my-2">
                  <button
                    className="  text-black py-1 px-2 rounded"
                    onClick={() => {
                      handlePriceSelect("");
                      setCurrentPage(1);
                    }}
                  >
                    Clear
                  </button>
                </div>
              )}
            </div>
            <Filter filterset={handleFilterSet} />
          </div>
        </div>
      )}

      <div className="flex w-full gap-6 lg:px-20">
        <div className="lg:w-[22%] hidden md:block">
          <div className="uppercase font-semibold text-2xl py-1">Filter</div>
          <div className=" p-1 rounded-md border-2">
            {/* <label htmlFor="price">Price</label> */}
            <div
              onClick={() => setIsOpen(!isOpen)}
              className="cursor-pointer py-2  px-3 flex justify-between items-center"
            >
              {/* {selectedPrice || "Select price"} */}
              <div className="text-lg">Price</div>
              <div>
                {isOpen ? (
                  <FaChevronDown color="gray" />
                ) : (
                  <FaChevronRight color="gray" />
                )}
              </div>
            </div>
            {isOpen && (
              <div className=" ml-4 py-2 space-y-2">
                <div>
                  <input
                    className=""
                    type="radio"
                    id="0-5000"
                    name="price"
                    value="0-5000"
                    checked={selectedPrice === "0-5000"}
                    onChange={() => handlePriceSelect("0-5000")}
                  />
                  <label htmlFor="0-5000" className="ml-2">
                    Below 5000
                  </label>
                </div>
                <div>
                  <input
                    type="radio"
                    id="5000-10000"
                    name="price"
                    value="5000-10000"
                    checked={selectedPrice === "5000-10000"}
                    onChange={() => handlePriceSelect("5000-10000")}
                  />
                  <label htmlFor="5000-10000" className="ml-2">
                    5000-10,000
                  </label>
                </div>
                <div>
                  <input
                    type="radio"
                    id="10000-20000"
                    name="price"
                    value="10000-20000"
                    checked={selectedPrice === "10000-20000"}
                    onChange={() => handlePriceSelect("10000-20000")}
                  />
                  <label htmlFor="10000-20000" className="ml-2">
                    10,000-20,000
                  </label>
                </div>
                <div>
                  <input
                    type="radio"
                    id="20000-50000"
                    name="price"
                    value="20000-50000"
                    checked={selectedPrice === "20000-50000"}
                    onChange={() => handlePriceSelect("20000-50000")}
                  />
                  <label htmlFor="20000-50000" className="ml-2">
                    Above 20,000
                  </label>
                </div>
                {/* Add more options here */}
              </div>
            )}
            {selectedPrice && (
              <div className="flex flex-row-reverse mr-2 my-2">
                <button
                  className="  text-black py-1 px-2 rounded"
                  onClick={() => handlePriceSelect("")}
                >
                  Clear
                </button>
              </div>
            )}
          </div>
          <Filter filterset={handleFilterSet} />
        </div>
        <div className="lg:w-[78%] w-full ">
          {isLoading ? (
            <>
              <ProductLoader />
            </>
          ) : (
            <>
              {/* <SearchProducts/> */}
              <div className="px-3 md:py-3 py-5 md:w-[100%] w-full text-center md:text-3xl inline-block font-bold">
                WOMEN COLLECTION
              </div>
              <div className="lg:w-[813px] hidden md:block text-center mx-auto mb-5 mt-2 text-sm">
                Daily-wear kurta sets to breezy loungewear, summer dresses to
                stunning lehengas, find everything you're looking for in our
                collection of onlineclothes for women.
              </div>
              <div className="flex bg-[#EAEAEA] border-t-4  border-b-4 items-center justify-between my-2 px-3 text-gray-700 py-2">
                <div
                  className="block md:hidden uppercase"
                  onClick={() => setShowFilter(true)}
                >
                  Filter
                </div>

                <div className="pr-2 hidden md:block">
                  {searchProducts?.length} Products
                </div>
                <div className="flex items-center gap-5">
                  {/* //add a togle btn for grid 3 and grid 4 */}
                  <div className="">
                    <Switch
                      onChange={handleChange}
                      checked={checked}
                      onColor="#86d3ff"
                      onHandleColor="#2693e6"
                      handleDiameter={25}
                      uncheckedIcon={uncheckedIcon}
                      checkedIcon={checkedIcon}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={30}
                      width={69}
                      className="react-switch"
                    />
                  </div>
                  <div>
                    <select
                      name="sort"
                      id="sort"
                      className="rounded-lg py-1 px-1 uppercase"
                      value={sortOption}
                      onChange={(e) => setSortOption(e.target.value)}
                    >
                      <option value="">Sort By</option>
                      {/* <option value="best">Best Selling</option>
                    <option value="low">Price, low to high</option>
                    <option value="high">Price, high to low</option> */}
                      <option value="1">Date, old to new</option>
                      <option value="-1">Date, new to old</option>
                    </select>
                  </div>
                </div>
              </div>
              {/* <div className="h-[220vh] bg-red-300"> */}
                <ProductCard data={searchProducts} gridStyle={checked} />
              {/* </div> */}
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </>
          )}
        </div>
      </div>
      <FooterHeader />
    </>
  );
}

export default SearchPage;
